import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const mobileDrawer = css`
  background-color: ${cssTheme.colors.warmGray[100].hex};
  overflow: initial;
`

export const floatingButton = css`
  position: absolute;
  bottom: 100%;
  margin: ${spacing(1)};
`

export const right = css`
  right: 0;
`

export const fullScreen = css`
  inset-block-start: 0;
  inset-inline: 0;
  max-inline-size: unset;
  border-radius: 0;
`
